import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["filterBtn", "ratingsList", "pagination", "loading"];
  static values = {
    url: String,
    eventId: Number
  };

  connect() {
    this.currentFilter = this.element.dataset.currentFilter || "";
    this.currentPage = 1;
  }

  filter(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const button = event.currentTarget;
    const filterType = button.dataset.filterType || "";
    
    // Update active state on buttons
    this.filterBtnTargets.forEach(btn => {
      btn.classList.remove("active");
    });
    button.classList.add("active");
    
    this.currentFilter = filterType;
    this.currentPage = 1;
    this.loadRatings();
  }

  paginate(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const page = event.currentTarget.dataset.page;
    if (page) {
      this.currentPage = parseInt(page);
      this.loadRatings();
    }
  }

  loadRatings() {
    // Show loading state
    if (this.hasLoadingTarget) {
      this.loadingTarget.style.display = "inline";
    }
    if (this.hasRatingsListTarget) {
      this.ratingsListTarget.style.opacity = "0.5";
    }
    
    // Build URL with params
    let url = `${this.urlValue}?event_id=${this.eventIdValue}&ratings_page=${this.currentPage}&ajax=1`;
    if (this.currentFilter) {
      url += `&rating_type=${this.currentFilter}`;
    }
    
    fetch(url, {
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    .then(response => response.text())
    .then(html => {
      // Parse the response and extract just the ratings content
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      
      // Update ratings list
      const newRatingsList = doc.querySelector("#ratings-list");
      if (newRatingsList && this.hasRatingsListTarget) {
        this.ratingsListTarget.innerHTML = newRatingsList.innerHTML;
      }
      
      // Update pagination - get the inner content
      const newPagination = doc.querySelector("#ratings-pagination");
      if (this.hasPaginationTarget && newPagination) {
        this.paginationTarget.innerHTML = newPagination.innerHTML;
      } else if (this.hasPaginationTarget) {
        this.paginationTarget.innerHTML = "";
      }
      
      // Hide loading state
      if (this.hasLoadingTarget) {
        this.loadingTarget.style.display = "none";
      }
      if (this.hasRatingsListTarget) {
        this.ratingsListTarget.style.opacity = "1";
      }
    })
    .catch(error => {
      console.error("Error loading ratings:", error);
      if (this.hasLoadingTarget) {
        this.loadingTarget.style.display = "none";
      }
      if (this.hasRatingsListTarget) {
        this.ratingsListTarget.style.opacity = "1";
      }
    });
  }
}
